/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Ccsl_DescInputs */

const en_file_export_ccsl_desc = /** @type {(inputs: File_Export_Ccsl_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Film industry spotting list`)
};

const fr_file_export_ccsl_desc = /** @type {(inputs: File_Export_Ccsl_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste de reperage de l'industrie cinematographique`)
};

const de_file_export_ccsl_desc = /** @type {(inputs: File_Export_Ccsl_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichtungsliste der Filmindustrie`)
};

const it_file_export_ccsl_desc = /** @type {(inputs: File_Export_Ccsl_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista di avvistamento dell'industria cinematografica`)
};

const ru_file_export_ccsl_desc = /** @type {(inputs: File_Export_Ccsl_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Список потенциальных участников киноиндустрии`)
};

const es_file_export_ccsl_desc = /** @type {(inputs: File_Export_Ccsl_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de avistamientos de la industria cinematográfica`)
};

const zh_cn2_file_export_ccsl_desc = /** @type {(inputs: File_Export_Ccsl_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电影行业观察名单`)
};

const ja_file_export_ccsl_desc = /** @type {(inputs: File_Export_Ccsl_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`映画業界のスポッティングリスト`)
};

const hi_file_export_ccsl_desc = /** @type {(inputs: File_Export_Ccsl_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फिल्म उद्योग में नज़र आने वालों की सूची`)
};

const pt_pt2_file_export_ccsl_desc = /** @type {(inputs: File_Export_Ccsl_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de identificação da indústria cinematográfica`)
};

/**
* | output |
* | --- |
* | "Film industry spotting list" |
*
* @param {File_Export_Ccsl_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_ccsl_desc = /** @type {((inputs?: File_Export_Ccsl_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Ccsl_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_ccsl_desc(inputs)
	if (locale === "de") return de_file_export_ccsl_desc(inputs)
	if (locale === "it") return it_file_export_ccsl_desc(inputs)
	if (locale === "ru") return ru_file_export_ccsl_desc(inputs)
	if (locale === "es") return es_file_export_ccsl_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_ccsl_desc(inputs)
	if (locale === "ja") return ja_file_export_ccsl_desc(inputs)
	if (locale === "hi") return hi_file_export_ccsl_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_ccsl_desc(inputs)
	return en_file_export_ccsl_desc(inputs)
});